import moment from 'moment';
import React, { useEffect, useState } from 'react';
import Dropdown from '../../../Components/Dropdown';
import { DayPickerRangeController } from 'react-dates';
import Btn from '../../../Components/Btn';
import 'moment-timezone';
import  SectionMessage  from '../../../Components/SectionMessage';

const DatePickerComponent = ({
	momentStartDate,
	momentEndDate,
	handleOnDateChange,
	limitOfAggregatedVisitorJourney,
	label
}) => {
	const [focused, setFocused] = useState<null | 'startDate' | 'endDate'>('startDate');
	const [dropdownIsOpen, setDropdownIsOpen] = useState(false);
	const [btn, setBtn] = useState(<></>);
	const [start, setStart] = useState<moment.Moment | null>(null);
	const [endD, setEndD] = useState<moment.Moment | null>(null);
	const [errorMessage, setErrorMessage] = useState('');

	const onFocused = (focusedInput) => {
		setFocused(focusedInput || 'startDate');
	};

	useEffect(() => {
		if (momentStartDate && momentEndDate && limitOfAggregatedVisitorJourney) {
			setStart(moment(momentStartDate.format('YYYY-MM-DD'), 'YYYY-MM-DD'));
			setEndD(moment(momentEndDate.format('YYYY-MM-DD'), 'YYYY-MM-DD'));
		}	
	}, [momentStartDate, momentEndDate, limitOfAggregatedVisitorJourney]);

	useEffect(() => {
		const button = (
			<button className='custom_input clickable m w_auto bg_white' style={{ height: '46px' }}>
				<span className="custom_input_value has_label">
					<span className='custom_input_value_label'>{label}</span>
					<span className="custom_input_placeholder">
						{start ? start.format('DD/MM/YYYY') : ''}
						<i className="analytics_range_arrow fas fa-arrow-right"></i>
						{endD ? endD.format('DD/MM/YYYY') : ''}
					</span>
				</span>
				<i className='custom_input_icon fas fa-calendar-alt'></i>
			</button>
		);
		setBtn(button);
	}, [start, endD]);

	useEffect(() => {
		if (start && endD && focused === 'endDate') {
			const maxAllowedEndDate = moment(start).add(limitOfAggregatedVisitorJourney.maxAllowedDaysToRequest, 'days');
			const maxEndDate = moment(limitOfAggregatedVisitorJourney.maxEndDate);

			if (endD.isAfter(maxAllowedEndDate, 'day') || endD.isAfter(maxEndDate, 'day')) {
				const updatedEndDate = maxAllowedEndDate.isBefore(maxEndDate) ? maxAllowedEndDate : maxEndDate;
				setEndD(updatedEndDate);
				setErrorMessage(`Due to your selection, we detected an error on the maximum range. We automatically updated your end date to ${updatedEndDate.format('DD/MM/YYYY')}.`);
			}
		}
	}, [start, endD, focused]);

	function handleValidDate() {
		if (handleOnDateChange) {
			handleOnDateChange({ startDate: start, endDate: endD });
			setDropdownIsOpen(false);
		}
	}

	const isOutsideRange = (day: moment.Moment) => {
		const minStartDate = moment(limitOfAggregatedVisitorJourney.minStartDate);
		const maxEndDate = moment(limitOfAggregatedVisitorJourney.maxEndDate);

		if (!start) {
			return day.isBefore(minStartDate, 'day') || day.isAfter(maxEndDate, 'day');
		}


		if (focused === 'endDate') {
			const maxAllowedEndDate = moment(start).add(limitOfAggregatedVisitorJourney.maxAllowedDaysToRequest, 'days');
			return (
				day.isBefore(minStartDate, 'day') ||
				day.isAfter(maxEndDate, 'day') ||
				day.isAfter(maxAllowedEndDate, 'day')
			);
		}

		return day.isBefore(minStartDate, 'day') || day.isAfter(maxEndDate, 'day');
	};

	function handleOnDateChangeStartAndEndDate(dates: { s: moment.Moment; e: moment.Moment }) {
		setStart(dates.s);
		setEndD(dates.e);
		setErrorMessage(''); 
	}

	if (!momentStartDate || !momentEndDate || !limitOfAggregatedVisitorJourney) return <></>;

	return (
		<Dropdown
			isOpen={dropdownIsOpen}
			setIsOpen={() => setDropdownIsOpen(true)}
			onHide={() => setDropdownIsOpen(false)}
			button={btn}
			flip={false}
		>
			<DayPickerRangeController
				startDate={start}
				endDate={endD}
				onDatesChange={({ startDate: s, endDate: e }) => {
					handleOnDateChangeStartAndEndDate({ s, e });
				}}
				focusedInput={focused}
				onFocusChange={onFocused}
				numberOfMonths={3}
				daySize={32}
				firstDayOfWeek={1}
				isOutsideRange={isOutsideRange}
			/>
			{errorMessage && 
				<SectionMessage
					type='information'
					color='purple'
					icon='fas fa-clock'
					text={errorMessage || ''}
					verticalSize="s"
				/>
			}
			<div className='section has_top_border'>
				<Btn
					onClickFunction={handleValidDate}
					message="Confirm"
					color="primary"
				/>
			</div>
		</Dropdown>
	);
};

export default DatePickerComponent;
